
// MSAL configuration object
export const msalConfig = {
    auth: {
        clientId: "ff71db7f-df33-481c-8e1d-21a228412799", // Azure AD Client ID
        authority: "https://login.microsoftonline.com/b1aae949-a5ef-4815-b7af-f7c4aa546b28", // Azure AD Tenant ID
        redirectUri: process.env.REACT_APP_MSAL_REDIRECT_URI // Your redirect URI
    },
    cache: {
      cacheLocation: "localStorage", // or localStorage if you prefer
      storeAuthStateInCookie: false,
    }
};

